
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/syncs/warehouse-sync-logs",
      function () {
        return require("private-next-pages/syncs/warehouse-sync-logs.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/syncs/warehouse-sync-logs"])
      });
    }
  